module.exports = __webpack_public_path__ + "img/13.E.e9264c62.jpg";